// extracted by mini-css-extract-plugin
export var blockBtn = "videoPresentation-module--block-btn--a6773";
export var mainBtn = "videoPresentation-module--main-btn--763b7";
export var mainTitle = "videoPresentation-module--main-title--f4f03";
export var title = "videoPresentation-module--title--ae09d";
export var videoPresentation = "videoPresentation-module--video-presentation--bad0f";
export var videoPresentation__text = "videoPresentation-module--video-presentation__text--27e44";
export var videoPresentation__video = "videoPresentation-module--video-presentation__video--ce192";
export var videoPresentation__wrapper = "videoPresentation-module--video-presentation__wrapper--53cc5";